import { render, staticRenderFns } from "./ProductionOrderCardContent.vue?vue&type=template&id=d0ad3a04&"
import script from "./ProductionOrderCardContent.vue?vue&type=script&lang=js&"
export * from "./ProductionOrderCardContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports